<template>

    <div class="icon-scroller">
        <div class="icon-scroller-track">
            <div v-for="(icon, index) in icons" :key="`is-${index}`" class="icon" :class="{ selected: icon === key }" @click="selectIcon(icon)">
                <i :class="icon" />
            </div>
        </div>
    </div>

</template>

<style lang="scss" scoped>

    .icon-scroller {
        overflow-x: auto;
        overflow-y: hidden;
        .icon-scroller-track {
            display: flex;
            flex-wrap: nowrap;
            gap: 5px;
            padding-bottom: 5px;
        }
    }

    .icon {
        align-items: center;
        background: $color-white;
        border: 1px solid $color-rule;
        border-radius: 5px;
        color: $color-text;
        cursor: pointer;
        display: flex;
        flex-shrink: 0;
        font-size: 16px;
        justify-content: center;
        height: 50px;
        transition: all .3s;
        width: 50px;
        &:hover {
            border-color: $color-text;
        }
        &.selected {
            background-color: $color-text;
            border-color: $color-text;
            color: $color-white;
        }
    }

</style>

<script>

export default {

    props: {
        icons: {
            type: Array,
            default: () => [],
        },
        model: {
            required: true,
        },
    },

    data() {
        return {
            key: null,
            defaultIcons: [
                'fas fa-tag',
                // General feedback
                'fas fa-star', // rating
                'fas fa-thumbs-up', // positive
                'fas fa-thumbs-down', // negative
                'fas fa-heart', // favorite / loved it
                'fas fa-comment', // review/comment
                'fas fa-comments', // discussion
                'fas fa-message', // message/feedback
                // Service & support
                'fas fa-headset', // customer support
                'fas fa-hands-holding-heart', // care / service
                'fas fa-handshake', // trust / professionalism
                'fas fa-bell-concierge', // attentive service
                // Quality & excellence
                'fas fa-trophy', // top quality / achievement
                'fas fa-medal', // award / recognition
                'fas fa-award', // excellence
                'fas fa-sparkles', // premium / special
                // Delivery & speed
                'fas fa-truck-fast', // fast shipping/delivery
                'fas fa-bolt', // speed / efficiency
                'fas fa-plug', // convenience / tech-ready
                // Product & offerings
                'fas fa-utensils', // food / restaurant
                'fas fa-pot-food', // meals / prepared food
                'fas fa-flower-tulip', // gifts / decor / beauty
                'fas fa-palette', // art / design / creativity
                'fas fa-wrench', // repair / maintenance
                'fas fa-toolbox', // DIY / tools
                'fas fa-store', // physical location / retail
                'fas fa-house-chimney-heart', // home / comfort / hospitality
                // Technology
                'fas fa-mobile', // mobile apps / accessibility
                'fas fa-desktop', // software / online service
            ],
        };
    },

    created() {
        if (this.icons.length === 0) {
            this.icons = this.defaultIcons;
        }
        const resolved = this.resolveSelection(this.model);
        this.key = resolved;
        if (!this.model || this.model !== resolved) {
            this.$emit('input', resolved);
        }
    },

    mounted() {
        this.$nextTick(() => this.scrollSelectedIntoView());
    },

    watch: {
        model(val) {
            this.key = this.resolveSelection(val);
        },
    },

    methods: {

        resolveSelection(val) {
            if (val && this.icons.includes(val)) return val;
            return this.icons[0] ?? null;
        },

        scrollSelectedIntoView() {
            const el = this.$el?.querySelector('.icon.selected');
            if (el) el.scrollIntoView({ block: 'nearest', inline: 'center' });
        },

        selectIcon(icon) {
            this.key = icon;
            this.$emit('input', icon);
        },
    },

}

</script>
